import styled from '@emotion/styled';
import { Fade, Grid, Typography } from '@mui/material';
import Image from 'next/image';
import { useState } from 'react';
import { nextImageTransitionProps } from '@/constants/next-image-transition-props';
import { config } from '@/config/environment';
import Galaxy from './components/galaxy';
import { textStrings } from './constants';

const MainDiv = styled.div`
  background: #231727;
  width: 100%;
  height: fit-content;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;
const FirstStarVector = styled(Image)`
  width: 12.5%;
  height: auto;
  margin-top: 390px;
  position: absolute;

  @media (max-width: 960px) {
    display: none;
  }
`;
FirstStarVector.defaultProps = {
  ...nextImageTransitionProps,
  style: undefined,
};
const BottomDiv = styled.div`
  height: auto;
  position: relative;
  background: #231727;
  margin-bottom: 100px;
`;

const NoContentDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;
const SecondStarVector = styled(Image)`
  height: auto;
  width: 22vw;

  @media (max-width: 960px) {
    width: 36vw;
    max-width: 160px;
  }
`;
SecondStarVector.defaultProps = {
  ...nextImageTransitionProps,
  style: undefined,
};
const ThirdStarVector = styled(Image)`
  left: 90px;
  top: 0;
  position: absolute;
  height: auto;
  width: 32.43%;

  @media (max-width: 960px) {
    display: none;
  }
`;
ThirdStarVector.defaultProps = {
  ...nextImageTransitionProps,
  style: undefined,
};
const Text = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-size: 16px;
  line-height: 160%;
  color: #ffffff;
  text-align: start;
`;
const GalaxyTextDiv = styled.div`
  max-height: 700px;
  text-align: start;
  position: relative;
  width: 25.83%;
  z-index: 2;
  opacity: 1;

  @media (max-width: 960px) {
    width: 100%;
    max-height: none;
    margin-bottom: 40px;
  }
`;
const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: opacity 1s linear;
`;
const TextDiv = styled(Grid)`
  max-height: 700px;
  text-align: start;
  position: relative;
  z-index: 4;
  ${Text} {
    width: 97.59%;
  }
`;
const MainTitle = styled(Typography)`
  font-family: var(--font-cooper-light), sans-serif;
  font-size: 50px;
  line-height: 109.3%;
  margin-bottom: 50px;
  text-align: start;

  @media (max-width: 960px) {
    font-size: 36px;
    margin-bottom: 24px;
  }
`;
const Subtitle = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 137.8%;
  color: #ffffff;
  text-align: start;
  transition: opacity 1s linear;

  @media (max-width: 960px) {
    font-size: 18px;
  }
`;
const Title = styled(Typography)`
  font-family: var(--font-cooper-light), sans-serif;
  font-size: 40px;
  line-height: 112.3%;
  color: #ffffff;
  margin-bottom: 30px;
  text-align: start;

  @media (max-width: 960px) {
    font-size: 30px;
    margin-bottom: 20px;
  }
`;
const MomentsDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: auto;
  padding-top: 13.8%;
  padding-left: 12.5%;

  @media (max-width: 960px) {
    flex-direction: column;
    padding: 96px 20px 0;
  }
`;
const Galaxies = styled.div`
  width: 74.17%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 960px) {
    width: 100%;
    gap: 20px;
  }
`;
const GalaxyGroup1 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  @media (max-width: 960px) {
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px 12px;
  }
`;
const GalaxyGroup2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-left: 100px;

  @media (max-width: 960px) {
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px 12px;
    padding-left: 0;
  }
`;
const GalaxyLeft = styled.div`
  margin: 0 10% 5% 5%;

  @media (max-width: 960px) {
    margin: 0;
  }
`;
const GalaxyRight = styled.div`
  margin: 5% 10% 0 5%;

  @media (max-width: 960px) {
    margin: 0;
  }
`;
const Div = styled(Grid)`
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 19% 12.5%;
  ${TextDiv} {
    width: 500px;
  }

  @media (max-width: 960px) {
    flex-direction: column;
    padding: 96px 20px 72px;
    align-items: flex-start;

    ${TextDiv} {
      width: 100%;
    }
  }
`;
const Blob = styled(Image)`
  height: auto;
  /* width: calc(50% + 200px); */
  width: 72.43%;
  position: absolute;
  overflow: hidden;
  right: 0;
  z-index: 3;
  top: 100px;

  @media (max-width: 960px) {
    width: 90%;
    top: 180px;
    opacity: 0.5;
  }
`;
Blob.defaultProps = {
  ...nextImageTransitionProps,
  style: undefined,
};
const Blob2 = styled(Image)`
  height: auto;
  /* width: calc(35% + 200px); */
  width: 58.68%;
  object-fit: cover;
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;

  @media (max-width: 960px) {
    width: 90%;
    opacity: 0.5;
  }
`;
Blob2.defaultProps = {
  ...nextImageTransitionProps,
  style: undefined,
};

const ImageDiv = styled(Grid)`
  height: auto;
  position: relative;
  z-index: 5;

  @media (max-width: 960px) {
    width: 100%;
    margin-bottom: 32px;
  }
`;

const VideoWrapper = styled.div`
  width: 80%;
  height: auto;
  border-radius: 28px;
  overflow: hidden;

  @media (max-width: 960px) {
    width: 100%;
  }
`;

const Moments = () => {
  const archiveMode = config.platformMode === 'archive';
  const [textSwitch, setTextSwitch] = useState<boolean>(true);
  const [galaxyOpacity, setGalaxyOpacity] = useState<number>(1);
  const [state, setState] = useState({
    activeGalaxy: '',
    displayDefault: true,
    text: archiveMode
      ? "Just like Earth's galaxy, the Milky Way, is made-up of millions of stars, the Curiko galaxy was made-up of so many moments. Click to explore the different kinds of moments..."
      : `Just like Earth's galaxy, the Milky Way, is made-up of millions of stars, the Curiko galaxy is made-up of so many moments. Click to explore the different kinds of moments we're all about...  `,
    subtitle: '',
    title: '',
  });

  const handleMomentSelect = (selectedGalaxy: string) => {
    const value = textStrings[selectedGalaxy as keyof typeof textStrings];
    setTextSwitch(!textSwitch);
    setGalaxyOpacity(0.3);
    setTimeout(() => {
      setState({
        ...state,
        activeGalaxy: selectedGalaxy,
        displayDefault: false,
        text: value.text,
        subtitle: value.subtitle,
        title: value.title,
      });
      setTextSwitch(!!textSwitch);
    }, 500);
  };

  return (
    <MainDiv>
      <FirstStarVector src="/galaxy-moments/vector11.png" alt="stars" />
      <MomentsDiv>
        <GalaxyTextDiv>
          <MainTitle style={{ color: state.displayDefault ? '#FFFFFF' : '#4C3B51' }}>
            {'A galaxy of moments'}
          </MainTitle>
          <Fade in={textSwitch} timeout={500}>
            <TextSection>
              <Subtitle>{state.subtitle}</Subtitle>
              <Title>{state.title}</Title>
              <Text style={{ opacity: state.displayDefault ? 0.6 : 1 }}>{state.text}</Text>
            </TextSection>
          </Fade>
        </GalaxyTextDiv>
        <Galaxies>
          <GalaxyGroup1>
            <GalaxyLeft onClick={() => handleMomentSelect('humanProject')}>
              <Galaxy
                label="purpose & meaning"
                vector="/galaxy-moments/group6958.png"
                labelColor="#96CE95"
                opacity={state.activeGalaxy === 'humanProject' ? 1 : galaxyOpacity}
              />
            </GalaxyLeft>
            <GalaxyRight
              onClick={() => {
                handleMomentSelect('cultureAndSpirit');
              }}
            >
              <Galaxy
                label="culture & spirit"
                vector="/galaxy-moments/group7019.png"
                labelColor="#D3A980"
                opacity={state.activeGalaxy === 'cultureAndSpirit' ? 1 : galaxyOpacity}
              />
            </GalaxyRight>
          </GalaxyGroup1>
          <GalaxyGroup2>
            <GalaxyLeft
              onClick={() => {
                handleMomentSelect('selfAndBody');
              }}
            >
              <Galaxy
                label="self & body"
                vector="/galaxy-moments/group7020.png"
                labelColor="#F1CABA"
                opacity={state.activeGalaxy === 'selfAndBody' ? 1 : galaxyOpacity}
              />
            </GalaxyLeft>
            <GalaxyRight
              onClick={() => {
                handleMomentSelect('others');
              }}
            >
              <Galaxy
                label="others"
                vector="/galaxy-moments/group7021.png"
                labelColor="#FDF3DE"
                opacity={state.activeGalaxy === 'others' ? 1 : galaxyOpacity}
              />
            </GalaxyRight>
          </GalaxyGroup2>
          <GalaxyGroup1>
            <GalaxyLeft
              onClick={() => {
                handleMomentSelect('socialJustice');
              }}
            >
              <Galaxy
                label="social justice"
                vector="/galaxy-moments/group70221.png"
                labelColor="#8FBFBB"
                opacity={state.activeGalaxy === 'socialJustice' ? 1 : galaxyOpacity}
              />
            </GalaxyLeft>
            <GalaxyRight
              onClick={() => {
                handleMomentSelect('place');
              }}
            >
              <Galaxy
                label="place"
                vector="/galaxy-moments/group7023.png"
                labelColor="#BF9BB9"
                opacity={state.activeGalaxy === 'place' ? 1 : galaxyOpacity}
              />
            </GalaxyRight>
          </GalaxyGroup1>
        </Galaxies>
      </MomentsDiv>
      <NoContentDiv>
        <SecondStarVector src="/galaxy-moments/vector10.png" alt="" />
      </NoContentDiv>
      <BottomDiv>
        <Blob src="/galaxy-moments/group7028.png" alt="" />
        <Blob2 src="/galaxy-moments/vector8.png" alt="" />
        <Div container>
          <ThirdStarVector src="/galaxy-moments/starvector.png" alt="" />
          <ImageDiv item md={6}>
            <VideoWrapper>
              <Image
                {...nextImageTransitionProps}
                src={'/galaxy-moments/main.png'}
                alt={'two members'}
              />
            </VideoWrapper>
          </ImageDiv>
          <TextDiv item md={6}>
            <Title>{'So what is a moment of connection?'}</Title>
            <Text>
              {`A moment of connection is an event or experience in our life where we feel a little
              more whole. A flourishing life is full of big and small moments of connection— whether
              to ourselves, to the people and places around us, to culture, or society. That looks
              like everything from a moment of enjoying the sunshine, to a moment of laughing with a
              stranger, to a moment of feeling seen & heard.`}
            </Text>
          </TextDiv>
        </Div>
      </BottomDiv>
    </MainDiv>
  );
};

export default Moments;
